import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { Box, Text, Flex, Button, Divider } from "@chakra-ui/react";

import Topbar from "components/topbar";
import TextArea from "./components/TextArea";
import TextInput from "./components/TextInput";
import MainLayout from "components/mainLayout";
import { useShipmentForm } from "context/DHLShipmentFormContext";
import FormikSelect from "components/formikSelect";

const AddressDetails = () => {
  const navigate = useNavigate();
  const { formData, updateFormData } = useShipmentForm();

  const validationSchema = Yup.object({
    requestType: Yup.string()
      .required("Request type is required")
      .min(3, "Must be at least 3 characters"),

    description: Yup.string()
      .required("Description is required")
      .max(300, "Maximum 300 characters allowed"),
  });

  const initialValues = {
    requestType: "commercial",
    description: formData?.request?.description,
  };

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              updateFormData({ request: values });
              navigate("/send-a-bag/dhl/package-details");
            }}
          >
            {(formik) => (
              <Form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  height: "100%",
                }}
              >
                <Flex flexDirection={"column"} flex={1}>
                  <Flex flexDirection={"column"} gap={6} flex={1}>
                    <Box>
                      <Text
                        fontFamily={"PlusJakartaSansSemiBold"}
                        fontSize={"16px"}
                        lineHeight={"20px"}
                        textTransform={"capitalize"}
                        color={"#000000"}
                      >
                        Shipment Details
                      </Text>
                      <Flex
                        gap={4}
                        marginTop={2}
                        borderWidth={"1px"}
                        borderColor={"#D9D9D9"}
                        borderStyle={"solid"}
                        padding={4}
                        borderRadius={"6px"}
                        flexDirection={"column"}
                      >
                        <Flex>
                          <FormikSelect
                            formik={formik}
                            name="requestType"
                            label={"Request Type"}
                          >
                            <option value="commercial">Packages</option>
                          </FormikSelect>
                        </Flex>
                        <Flex>
                          <TextArea
                            formik={formik}
                            name="description"
                            label={"Summarise the contents of your shipment"}
                            placeholder={"Children’s Clothes"}
                          />
                        </Flex>
                      </Flex>
                    </Box>
                  </Flex>
                  <Flex>
                    <Flex>
                      <Button
                        onClick={() => navigate(-1)}
                        width={"148px"}
                        borderRadius={8}
                        bg={"none"}
                        border={"1px solid #000000"}
                        color={"#000000"}
                        fontSize={"12px"}
                        fontWeight={"500"}
                        fontFamily={"PlusJakartaSansMedium"}
                        letterSpacing={0.2}
                      >
                        Back
                      </Button>
                    </Flex>
                    <Flex
                      alignSelf={"flex-end"}
                      alignItems={"flex-end"}
                      justifyContent={"flex-end"}
                      bottom={0}
                      w={"100%"}
                      gap={2}
                      // mt={4}
                    >
                      <Button
                        onClick={() => formik.handleSubmit()}
                        flex={1}
                        maxW={"148px"}
                        background={"#000000"}
                        color={"#FFFFFF"}
                        borderRadius={8}
                        fontSize={"12px"}
                        fontFamily={"PlusJakartaSansMedium"}
                        textTransform={"uppercase"}
                        _disabled={{
                          bg: "grey.100",
                          cursor: "default",
                          _hover: {
                            bg: "grey.100",
                            cursor: "default",
                          },
                        }}
                      >
                        Next
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export default AddressDetails;
